// @flow
export const MODEL = 'SoilJobs'
export const URL = 'soilsampling/job/'

// Categories
// TODO if required

// Model Attributes
export const PROP_ID = 'id'
export const PROP_SOIL_JOB_ID = PROP_ID
export const PROP_DATE = 'date'
export const PROP_AREA = 'area'
export const PROP_PRICE = 'price'
export const PROP_CREATED_BY = 'created_by'
export const PROP_COMPLETED_BY = 'completed_by'
export const PROP_ASSIGNED_TO = 'assigned_to'
export const PROP_CREATED_DATE = 'created_date'
export const PROP_COMPLETE = 'complete'
export const PROP_COMPLETED_DATE = 'completed_date'
export const PROP_SAMPLING_TYPE = 'samplingType'
export const PROP_STATUS = 'status'
export const PROP_GRID_SIZE = 'grid_size'
export const PROP_ACTION = 'action'
export const PROP_SUBFIELD = 'subfield'
export const PROP_FIELD = 'field'
export const PROP_FARM = 'farm'
export const PROP_GROWER = 'grower'

export const DATE_FORMAT = 'YYYY-MM-DD'
export const READY_TO_SAMPLE = 'Ready to Sample'
export const SAMPLING = 'Sampling'
export const RESULTS_POSTED = 'Results Posted'
export const SHIPPING = 'Shipping'
export const ORDER_TEST = 'Order Test'

/* This defines the realm schema used by the mobile team for
    offline data storage. If you have questions please ask anyone
    on the mobile team.
  Valid types are:
  string: a string
  int: any non-floating point number
  float: any floating point number
  double: a double precision floating point number
  bool: a javascript boolean
  data: if you are unfamiliar with realm don't use this
  date: maps to javascript Date
*/
export const SCHEMA = [{
  name: MODEL,
  primaryKey: PROP_ID,
  properties: {
    id: {type: 'int'},
    created_by: {type: 'string'},
    completed_by: {type: 'string', optional: true},
    assigned_to: {type: 'string', optional: true},
    created_date: {type: 'string', optional: true},
    complete: {type: 'bool', default: false},
    completed_date: {type: 'string', optional: true},
    samplingType: {type: 'string', optional: true},
    status: {type: 'string', optional: true},
    grid_size: {type: 'int', optional: true},
    subfield: {type: 'int', optional: true},
    action: {type: 'int', optional: true},
    field: {type: 'int', optional: true},
    farm: {type: 'int', optional: true},
    grower: {type: 'int', optional: true},
    previous_points: {type: 'string', optional: true},
  },
}]
